module.exports = __webpack_public_path__ + "img/dispatch_server_error.39102641.svg";